// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	googleMapsApiKey: 'AIzaSyD6_zAOaRGLnVpP4igmLxNJARc9u4kzzHY',
	agencyHost: 'https://staging-agency-mlmg.web.app',
	adminHost: 'https://staging-admin-mlmg.web.app',
	wordpressHost: 'https://staging2.mylifemygift.com',
	startQuiz: 'https://staging-start-mlmg.web.app',
	chatWidgetHost: 'https://staging-chat-mlmg.web.app',
	liftHost: 'https://staging-lift-mlmg.web.app',
	cookieDomain: 'staging-family-finder.web.app',
	lifelineAgencyId: 'i31WIQcH2rFAdMnbcBLz', //Clear Test Agency
	familyFinderHost: 'https://staging-family-finder.web.app',
	familyPortalHost: 'https://staging-family-portal.web.app',
	defaultAgencyId: `i31WIQcH2rFAdMnbcBLz`, //Lifeline
	firebase: {
		apiKey: 'AIzaSyAYtn1AyjTe1usg_-60VxIWV9byIrQ4vnI',
		authDomain: 'staging-mylifemygift.firebaseapp.com',
		projectId: 'staging-mylifemygift',
		storageBucket: 'staging-mylifemygift.appspot.com',
		messagingSenderId: '366118269506',
		appId: '1:366118269506:web:1cd14aba63f26c855373db'
	}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
